import { Helmet } from 'react-helmet-async';

const DEFAULT = {
  title: 'TrailCode — Salesforce Coding Challenges',
  description:
    'Master Salesforce development with hands-on Apex, SOQL, and LWC coding challenges. Free and Pro plans available.',
  url: 'https://trailcode.org',
  image: 'https://trailcode.org/og-image.png',
};

export default function SEO({ title, description, url, image, noIndex = false }) {
  const seo = {
    title: title ? `${title} | TrailCode` : DEFAULT.title,
    description: description || DEFAULT.description,
    url: url || DEFAULT.url,
    image: image || DEFAULT.image,
  };

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={seo.url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="TrailCode" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
    </Helmet>
  );
}